class KeyboardAccessoryView {
	static enable() {
		return null;
	}
	static disable() {
		return null;
	}
}
export { KeyboardAccessoryView };
